module.exports = __webpack_public_path__ + "static/media/35_B.cf2db75d.png";